<template>
  <div class="border py-3 px-4" style="max-width: 1000px;">
    <div class="row ">
      <!----------------------------------------------------------
            S U M M A R Y   H E A D E R   -   R O W   2   |   Gesamtauftrag, Hauptauftrag, 
      ----------------------------------------------------------->
      <div class="col">
        <label class="text-muted d-block mb-1"><small>Gesamtauftrag</small></label>
        <div class="bg-light p-1">
          {{ $utils.formatCurrency(parseFloat(order.Amount) + parseFloat(order.AmountAddendumOrdered), SettingsStore) }}
        </div>
      </div>
      <div class="col">
        <label class="text-muted d-block mb-1"><small>Hauptauftrag</small></label>
        <div class="bg-light p-1">
          {{ $utils.formatCurrency(order.Amount, SettingsStore) }}
        </div>
      </div>
      <div class="col">
        <label class="text-muted d-block mb-1"><small>Nachträge</small></label>
        <div class="bg-light p-1">
          {{ $utils.formatCurrency(order.AmountAddendumOrdered, SettingsStore) }}
        </div>
      </div>
      <div class="col">
        <label class="text-muted d-block mb-1"><small>Restbudget für Nachträge</small></label>
        <div class="bg-light p-1">
          {{
            $utils.formatCurrency(
              parseFloat(order.BudgetSaldo) - (parseFloat(order.Amount) + parseFloat(order.AmountAddendumOrdered)),
              SettingsStore
            )
          }}
        </div>
      </div>
    </div>
    <div class="row mt-0 " style="max-width: 1000px">
      <div class="col-3">
        <label class="text-muted d-block mb-1"><small>Auftragnehmer</small></label>
        <div class="bg-light p-1">
          {{ order.SupplierText }}
        </div>
      </div>
      <div class="col-6">
        <label class="text-muted d-block mb-1"><small>Auftragsstatus / Datum</small></label>
        <div class="bg-light p-1">
          {{ computeOrderStatus(order) }}
        </div>
      </div>
      <div class="col-3">
        <label class="text-muted d-block mb-1"><small>Nachträge in Prüfung</small></label>
        <div class="bg-light p-1">{{ $utils.formatCurrency(order.AmountAddendumChecking, SettingsStore) }}</div>
      </div>
    </div>
  </div>
</template>

<script>
import OrdersService from '@/service/OrdersService.js';
import SettingsStore from '@/store/Settings';
import AppState from '@/store/App.js';

export default {
  data() {
    return {
      SettingsStore,
      order: {}
    };
  },
  methods: {
    computeOrderStatus(item) {
      if (item.veSection && item.veSection == 'A') {
        return (
          (item.VergabeEmpfehlung && item.VergabeEmpfehlung != '' ? item.VergabeEmpfehlung : 'Empfehlung') +
          ' / ' +
          this.$utils.SQLDateToGermanDate(item.VergabeEmpfehlungDatum)
        );
      } else if (item.veSection && item.veSection == 'B') {
        return (
          (item.OrderNumber && item.OrderNumber != '' ? item.OrderNumber : 'Bestellung') +
          ' / ' +
          this.$utils.SQLDateToGermanDate(item.OrderDate)
        );
      } else return '';
    }
  },
  async activated() {
    this.order = await OrdersService.getByVeId(this.$router.currentRoute.params.id);
    AppState.isLoading = false;
  }
};
</script>

<style></style>
